import { inject, injectable } from 'inversify';
import { TYPES } from '@Types';
import { RequestAction, RequestFailure } from '../RequestAction';
import { RequestClubsSuccess } from './response';
import { Nullable } from '@Models';
import { ApiClient } from '@Api';
import { ClubMapper } from '@Mapper/federation/club.mapper';
import { Locale } from '@Repository/locale';

@injectable()
export class ClubRepository {
  @inject(TYPES.Locale) protected _locale!: Locale;
  @inject(TYPES.Mapper.ClubMapper) private _clubMapper!: ClubMapper;
  @inject(TYPES.Api.ApiClient) private _apiClient!: ApiClient;

  public async getAll({
    locale,
  }: {
    locale: Nullable<string>;
  }): Promise<RequestAction> {
    try {
      const clubsDto = await this._apiClient.federation.getClubs({
        locale: locale ?? this._locale.getlocale(),
      });

      return {
        payload: clubsDto.map((item) => this._clubMapper.map(item)),
      } satisfies RequestClubsSuccess as RequestClubsSuccess;
    } catch (error: any) {
      return new RequestFailure({ error: error });
    }
  }
}
